import axios from "axios"

const loadClients = (callback) => {
    const config = {
        url: '/api/clients',
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data));
}

const getClient = (id, callback) => {
    const config = {
        url: `/api/clients/${id}`,
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data));
}

const deleteClient = (id, callback) => {
    const config = {
        url: `/api/clients/${id}`,
        method: 'DELETE',
    }

    axios.request(config)
        .then(response => callback(response.data))
}

const save = (clientData, callback) => {
    const config = {
        url: clientData.id ? `/api/clients/${clientData.id}` : '/api/clients',
        method: clientData.id ? 'PUT' : 'POST',
        data: clientData,
    }

    axios.request(config)
        .then(response => callback(response.data))
}


const ClientActions = {
    loadClients,
    getClient,
    save,
    deleteClient
}

export default ClientActions